import { materials as MaterialsService } from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';

export const createCommentStart = () => ({
  type: coursesTypes.UPDATE_MATERIAL_START,
});

export const createCommentEnd = () => ({
  type: coursesTypes.UPDATE_MATERIAL_END,
});

export default ({ noteId, data, callback }) =>
  async dispatch => {
    try {
      dispatch(createCommentStart());
      await MaterialsService.addNoteComment({ noteId, content: data });
      if (callback) await callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(createCommentEnd());
    }
  };
